import {Get} from "../utils/requests";

const StoreService = {
    async get(store_slug) {
        let response = await Get(`/api/quick-menu/${store_slug}`);
        return response
    },
};

export default StoreService;